<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-19 15:20:36
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/detail/components/DetLogDet/index.vue
-->
<template>
  <!-- 订单详情商品当前物流信息 -->
  <div class="det_log_con">
    <img src="@/assets/order/icon_send@2x.png" alt="" class="cart_icon" />
    <div class="font12 font_weight400 colo087 text_left line_height_17">
      {{ trackingData.context }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    trackingData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
.det_log_con {
  background: #fff;
  margin: 0 16px 12px 16px;
  box-shadow: 0px 10px 10px -6px #f2f0f0;
  border-radius: 8px;
  padding: 12px 33px 12px 12px;
  display: flex;
  .cart_icon {
    width: 18px;
    height: 18px;
    margin-right: 6px;
  }
}
</style>
